import {
  createCommand,
  Option,
  InvalidArgumentError,
} from '@commander-js/extra-typings';
import { z } from 'zod';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import type { CommandServices } from '@wix/cli-command-contract';
import { runCommand } from './render-command.js';

export const token = (services: CommandServices) => {
  return createCommand('token')
    .description('Print the current access token, refreshing if needed')
    .option(
      '-s, --site <site-id>',
      'Get a site-scoped access token',
      validateSite
    )
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format').hideHelp()
    )
    .action(async (options, command) => {
      const { CliError, CliErrorCode } = await import('@wix/cli-error');
      const { isLoggedInToAccount } = await import('@wix/cli-auth');

      await runCommand(command, services, async () => {
        const authState = await isLoggedInToAccount();

        if (!authState) {
          throw new CliError({
            code: CliErrorCode.AuthenticationRequired(),
            cause: null,
          });
        }

        const accessToken = await authState.getAccessToken(
          options.site ? { siteId: options.site } : undefined
        );

        if (options.json) {
          process.stdout.write(`${JSON.stringify({ accessToken })}\n`);
        } else {
          process.stdout.write(`${accessToken}\n`);
        }
      });
    });
};

function validateSite(value: string) {
  const parsed = z.string().uuid().safeParse(value);
  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid GUID');
}
